import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import AnswerDragObjects from '../game/AnswerDragObjects';
import AnswerDropZone from '../game/AnswerDropZone';
import CorrectPercentDisplay from '../ui/CorrectPercentDisplay';
import FeedbackTextDisplay from '../ui/FeedbackTextDisplay';
import JrQuestionDisplay from '../game/JrQuestionDisplay';
import JrQuestionGenerator from '../game/JrQuestionGenerator';
import QuestionCorrectCounter from '../ui/QuestionCorrectCounter';
import RaceBanner from '../ui/RaceBanner';
import QuestionGenerator from '../game/QuestionGenerator';
import CompareNumbersDisplay from '../game/CompareNumbersDisplay';

/**
 * This is your first scene.
 */
export default class Questions extends Phaser.Scene {
  static get KEY() { return 'Questions'; }

  create() {
    this.correctCount = gameData.correctCount;
    this.totalAnswered = gameData.totalAnswered;
    this.waiting - false;
    this.correctStreak = 0;
    this.draggingTrash = [];
    this.isDragging = false;

    this.cameras.main.setBackgroundColor('#FFFFFF');

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);
    this.player = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.checkerHeader = ABCyaPhaser.Images.addImage(0, 0, 'CheckeredHeader', this).setOrigin(0, 0);
    this.checkerFooter = ABCyaPhaser.Images.addImage(0, this.mid.y * 2, 'CheckeredHeader', this).setScale(1, -1)
      .setOrigin(0, 0);

    this.trophyCounter = new QuestionCorrectCounter(this, 'trophy', 5, 'LblGet5');
    this.trophyCounter.y = this.checkerHeader.y + this.checkerHeader.getBounds().height + 20;
    this.trophyCounter.x = this.mid.x - this.trophyCounter.widthRef / 2;

    this.scoreDisplay = new CorrectPercentDisplay(this);
    this.scoreDisplay.x = this.mid.x * 2 - this.scoreDisplay.getBounds().width - 20;
    this.scoreDisplay.y = 22;

    this.answerDragObjects = new AnswerDragObjects(this);
    this.answerDragObjects.on('MAKE_DRAG_ITEM', (props) => { this.makeAnswerItem(props); });
    this.answerDragObjects.on('RELEASE_DRAG_ITEM', () => { this.releaseAnswerItem(); });
    this.answerDragObjects.x = this.mid.x - this.answerDragObjects.widthRef / 2;
    this.answerDragObjects.y = this.mid.y * 2 - 200;

    this.answerDropZone = new AnswerDropZone(this);
    this.answerDropZone.x = this.mid.x - this.answerDropZone.getBounds().width / 2;
    this.answerDropZone.y = this.mid.y - this.answerDropZone.getBounds().height / 2;
    this.answerDropZone.boundries = {};
    this.answerDropZone.boundries.left = this.answerDropZone.x;
    this.answerDropZone.boundries.top = this.answerDropZone.y;
    this.answerDropZone.boundries.right = this.answerDropZone.x + this.answerDropZone.getBounds().width;
    this.answerDropZone.boundries.bottom = this.answerDropZone.y + this.answerDropZone.getBounds().height;

    this.feedbackDisplay = new FeedbackTextDisplay(this);
    this.feedbackDisplay.setVisible(false);

    this.draggingItem = ABCyaPhaser.Images.addImage(0, 0, 'CircleEquals', this).setOrigin(0, 0);

    this.questionDisplay;
    if (gameData.GAME_TYPE === 'jr') {
      this.sndInstruct = ABCyaPhaser.Audio.playSound('raceway-06', this.player);
      this.questionGenerator = new JrQuestionGenerator();
      this.questionDisplay = new JrQuestionDisplay(this);
      this.questionDisplay.on('QUESTION_READY', () => { this.questionReady(); });
      this.questionDisplay.x = 42;
      this.questionDisplay.y = 210;
    }
    else {
      this.sndInstruct = ABCyaPhaser.Audio.playSound('raceway-05', this.player);

      this.questionGenerator = new QuestionGenerator(gameData.gametype, gameData.gamelevel);

      this.questionDisplay = new CompareNumbersDisplay(this);
      this.questionDisplay.on('QUESTION_READY', () => { this.questionReady(); });
      this.questionDisplay.x = 42;
      this.questionDisplay.y = 210;
    }
    this.player.once('complete', () => { this.playFiveInstruct(); });

    this.layoutRatio();

    this.nextQuestion();

    gameData.correctCount = this.correctCount;
    gameData.totalAnswered = this.totalAnswered;
  }

  playFiveInstruct() {
    this.sndInstruct = ABCyaPhaser.Audio.playSound('raceway-07', this.player);
  };

  nextQuestion() {
    this.answerDropZone.showQuestionMark();
    this.feedbackDisplay.cleanupCurrent();
    this.draggingItem.setVisible(false);
    const numberSet = this.questionGenerator.getNewNumberSet();
    this.questionDisplay.displayNumbers(numberSet[0], numberSet[1]);
    this.curQuestion = {};
    this.curQuestion.numberSet = numberSet;

    let n1;
    let n2;
    if (numberSet[0].type !== gameData.GAMETYPE_FRACTIONS) {
      n1 = numberSet[0].value;
    }
    else {
      n1 = numberSet[0].value.decimalValue;
    }
    if (numberSet[1].type !== gameData.GAMETYPE_FRACTIONS) {
      n2 = numberSet[1].value;
    }
    else {
      n2 = numberSet[1].value.decimalValue;
    }
    if (n1 === n2) {
      this.curQuestion.answer = gameData.EQ;
    }
    else if (n1 < n2) {
      this.curQuestion.answer = gameData.LT;
    }
    else if (n1 > n2) {
      this.curQuestion.answer = gameData.GT;
    }

    this.waiting = false;
  };

  questionReady() {
    this.answerDragObjects.showButtons();
  };

  // region ***** DRAG DROP ANSWER ******
  makeAnswerItem(props) {
    // console.log(this.draggingItem, this.draggingItem.scale, this.draggingItem.alpha);
    this.draggingItem.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, `Circle${props.answerType}`);
    this.draggingItem.setVisible(true).setAlpha(1)
      .setScale(1);
    this.draggingItem.answerType = props.answerType;
    this.draggingItem.x = props.loc.x + this.answerDragObjects.x + 55;
    this.draggingItem.y = props.loc.y + this.answerDragObjects.y + 5;
    this.isDragging = true;
    this.children.bringToTop(this.draggingItem);
  };

  releaseAnswerItem() {
    if (!this.isDragging || this.waiting) return;

    const b1 = {};
    b1.left = this.draggingItem.x;
    b1.top = this.draggingItem.y;
    b1.right = this.draggingItem.x + this.draggingItem.getBounds().width;
    b1.bottom = this.draggingItem.y + this.draggingItem.getBounds().height;

    let isCorrect = false;
    const hit = this.checkRectHit(b1, this.answerDropZone.boundries);
    if (hit) {
      isCorrect = this.draggingItem.answerType === this.curQuestion.answer;
      this.answerRegistered(this.draggingItem.answerType, isCorrect);
    }
    else {
      this.answerDragObjects.showButtons();
      this.draggingItem.setVisible(false);
    }
    this.isDragging = false;
  };

  answerRegistered(answerType, isCorrect) {
    this.totalAnswered++;
    let destX = 0;
    let destY = 0;
    let sx = 1; let sy = 1; let a = 1;
    if (isCorrect) {
      this.correctCount++;
      destX = this.answerDropZone.x - 1;
      destY = this.answerDropZone.y - 1;
      this.correctStreak++;
      sx = 1.2;
      sy = 1.2;
      ABCyaPhaser.Audio.playOneShot('correct_answer', this);
    }
    else {
      this.correctStreak = 0;
      destX = this.draggingItem.x;
      destY = this.draggingItem.y;
      sx = 2;
      sy = 2;
      a = 0;
      ABCyaPhaser.Audio.playOneShot('wrong_answer', this);
      this.answerDragObjects.showButtons();
    }

    if (!isCorrect) {
      const tmp = ABCyaPhaser.Images.addImage(0, 0, `Circle${this.draggingItem.answerType}`, this);
      tmp.isCorrect = isCorrect;
      tmp.x = this.draggingItem.x + this.draggingItem.getBounds().width / 2;
      tmp.y = this.draggingItem.y + this.draggingItem.getBounds().height / 2;
      destX = this.draggingItem.x + this.draggingItem.getBounds().width / 2;
      destY = this.draggingItem.y + this.draggingItem.getBounds().height / 2;
      ABCyaPhaser.Tweens.addTween(tmp, 350, { x: destX, y: destY, scaleX: sx, scaleY: sy, alpha: a }, Phaser.Math.Easing.Linear);
      this.answerDropZone.showIncorrect();
      this.draggingTrash.push(tmp);

      this.draggingItem.setVisible(false);
    }
    else {
      this.waiting = true;
      ABCyaPhaser.Tweens.addTween(this.draggingItem, 350, { x: destX, y: destY, scaleX: sx, scaleY: sy, alpha: a }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(this.draggingItem, 320, { delay: 200, alpha: 0 }, Phaser.Math.Easing.Linear);
      });
      this.answerDropZone.showCorrect();
    }

    this.feedbackDisplay.showFeedback(answerType, isCorrect, this.curQuestion.numberSet[0], this.curQuestion.numberSet[1]);
    this.feedbackDisplay.x = this.mid.x - this.feedbackDisplay.maxWidth / 2;
    this.feedbackDisplay.setVisible(true);
    this.trophyCounter.updateDisplay(this.correctStreak);


    // Finish or next question
    if (this.correctStreak >= 5) {
      gameData.correctCount = this.correctCount;
      gameData.totalAnswered = this.totalAnswered;
      this.time.delayedCall(1000, () => { this.allDone(); });
    }
    else {
      if (isCorrect) {
        this.time.delayedCall(1800, () => { this.nextQuestion(); });
      }
    }

    const score = Math.floor((this.correctCount / this.totalAnswered) * 100);
    this.scoreDisplay.updateScore(score);
  };

  // endregion **** DRAG DROP ANSWER ****

  allDone() {
    this.showCongrats();
    ABCyaPhaser.Tweens.addTween(this.answerDropZone, 220, { alpha: 0 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.questionDisplay, 220, { alpha: 0 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.feedbackDisplay, 220, { alpha: 0 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.answerDragObjects, 220, { alpha: 0 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.trophyCounter, 220, { alpha: 0 }, Phaser.Math.Easing.Linear);
  };

  showCongrats() {
    ABCyaPhaser.Audio.playOneShot('win_final_celebrate', this);

    this.time.delayedCall(800, () => { this.playEndSound(); });

    this.banner = new RaceBanner(this);

    this.banner.x = this.mid.x;
    this.banner.y = this.mid.y - 120;
    this.banner.setScale(0);
    this.banner.setAlpha(0);
    this.dotPop(this.banner, 400);

    this.fiveInARow = this.add.bitmapText(this.mid.x, this.mid.y + 105, 'asapBoldItalicSmall', ABCyaPhaser.Localization.instance.getLocalizedString('questions.title'), 48).setCenterAlign()
      .setOrigin(.5)
      .setAlpha(0);

    this.btnGo = this.add.container(0, 0).setAlpha(0);
    const btnGoBG = ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'BtnGo', null, () => {
      this.sound.stopAll();
      btnGoBG.setEnabled(false);
      this.showNextScene();
    }, this.btnGo, { disabledTint: '0xFFFFFF' }).setEnabled(false);
    const btnTxt = this.add.bitmapText(0, -4, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('buttons.go'), 48).setTintFill('0xFFFFFF')
      .setOrigin(.5);
    this.btnGo.add(btnTxt);

    this.btnGo.x = this.mid.x;
    this.btnGo.y = this.mid.y * 2 - this.btnGo.getBounds().height / 2 - 88;
  };

  dotPop(obj, time = 320, wait = 0, enableBtn = false) {
    ABCyaPhaser.Tweens.addTween(obj, 240, { delay: wait, scaleX: 1.6, scaleY: 1.6, alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(obj, time, { scaleX: 1.0, scaleY: 1.0, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
        if (enableBtn) obj.setEnabled(true);
      });
    });
  };

  playEndSound() {
    ABCyaPhaser.Audio.playOneShot('raceway_five_correct_in_row', this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.dotPop(this.btnGo, 400, 800);
    this.dotPop(this.fiveInARow, 400, 400);

    this.btnGo.list[0].setEnabled(true);
  };

  showNextScene() {
    this.scene.start('Intro');
  };

  checkRectHit(a, b) {
    return a.left <= b.right &&
      b.left <= a.right &&
      a.top <= b.bottom &&
      b.top <= a.bottom;
  };

  layoutRatio() {
    this.questionDisplay.scale = 1;
    this.questionDisplay.x = 42;
    this.questionDisplay.y = 188;
    this.feedbackDisplay.y = this.answerDropZone.y + 200;

    this.checkerFooter.y = this.mid.y * 2;
    this.answerDragObjects.y = this.mid.y * 2 - 200;
    this.answerDropZone.y = this.mid.y - this.answerDropZone.getBounds().height / 2;

    if (!this.questionDisplay.isJr) this.questionDisplay.layoutRatio();
  };
}